export enum SingleSignOnSetupState {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

interface SingleSignOnSettings {
  isEnabled: boolean;
  setupState: SingleSignOnSetupState;
}

export default SingleSignOnSettings;
